import { GoToCheckoutButton } from '#components/molecules/Cart/buttons/GoToCheckoutButton/GoToCheckoutButton.js';
import { WithConsolidatedCheckout } from '#components/molecules/WithConsolidatedCheckout/WithConsolidatedCheckout.js';
import { CartsDetails } from '#components/organisms/Carts/carts-details/CartsDetails.js';
import { useCartStorage } from '#hooks/useCartStorage';
import { Affix, Box, Container, Group, Stack } from 'ui';

import { NoCartData } from '../../components/molecules/NoCartData';
import { Carts } from '../../components/organisms/Carts/Carts';

const CartsPage = () => {
  const { cartCount } = useCartStorage();
  return (
    <Container size="xl">
      <Group
        justify="space-between"
        align="flex-start"
        wrap="nowrap"
        pb={{ base: 160, md: 0 }}
        gap="xl"
      >
        {cartCount ? (
          <Stack gap="xl" align="stretch" flex="1">
            <Carts />
          </Stack>
        ) : (
          <Container mt="lg" size="sm">
            <NoCartData />
          </Container>
        )}
        <WithConsolidatedCheckout>
          <Box visibleFrom="sm">
            <CartsDetails />
          </Box>
        </WithConsolidatedCheckout>
      </Group>
      <WithConsolidatedCheckout>
        <Affix hiddenFrom="sm" position={{ bottom: 0 }} w="100%" p="md" bg="white">
          <GoToCheckoutButton />
        </Affix>
      </WithConsolidatedCheckout>
    </Container>
  );
};

export default CartsPage;
